import { Routes } from '@angular/router'

// Inmueble → nivel → área → zona → sección. Las rutas anidadas se perdieron al pasar app.routes a menu.routes
// (8c914019): solo quedaba el listado y cualquier detalle caía en not-found. Mismas URLs que antes, sin el prefijo /main/tabs.
const BUILDING = 'building-detail'
const FLOOR = `${BUILDING}/floor-detail`
const AREA = `${FLOOR}/area-detail`
const ZONE = `${AREA}/zone-detail`
const SECTION = `${ZONE}/section-detail`

export const StorageLayoutRoutes: Routes = [
    {
        path: '',
        loadComponent: () =>
            import('@/app/domains/erp/storage-layout/pages/building-container/building-container.page').then(
                (m) => m.BuildingContainerPage
            ),
    },
    {
        path: BUILDING,
        loadComponent: () =>
            import('@/app/domains/erp/storage-layout/pages/building-detail/building-detail.page').then(
                (m) => m.BuildingDetailPage
            ),
    },
    {
        path: `${BUILDING}/building-edit`,
        loadComponent: () =>
            import('@/app/domains/erp/storage-layout/pages/building-edit/building-edit.page').then(
                (m) => m.BuildingEditPage
            ),
    },
    {
        path: FLOOR,
        loadComponent: () =>
            import('@/app/domains/erp/storage-layout/pages/floor-detail/floor-detail.page').then(
                (m) => m.FloorDetailPage
            ),
    },
    {
        path: `${FLOOR}/floor-edit`,
        loadComponent: () =>
            import('@/app/domains/erp/storage-layout/pages/floor-edit/floor-edit.page').then((m) => m.FloorEditPage),
    },
    {
        path: AREA,
        loadComponent: () =>
            import('@/app/domains/erp/storage-layout/pages/area-detail/area-detail.page').then((m) => m.AreaDetailPage),
    },
    {
        path: `${AREA}/area-edit`,
        loadComponent: () =>
            import('@/app/domains/erp/storage-layout/pages/area-edit/area-edit.page').then((m) => m.AreaEditPage),
    },
    {
        path: ZONE,
        loadComponent: () =>
            import('@/app/domains/erp/storage-layout/pages/zone-detail/zone-detail.page').then((m) => m.ZoneDetailPage),
    },
    {
        path: `${ZONE}/zone-edit`,
        loadComponent: () =>
            import('@/app/domains/erp/storage-layout/pages/zone-edit/zone-edit.page').then((m) => m.ZoneEditPage),
    },
    {
        path: SECTION,
        loadComponent: () =>
            import('@/app/domains/erp/storage-layout/pages/section-detail/section-detail.page').then(
                (m) => m.SectionDetailPage
            ),
    },
    {
        path: `${SECTION}/section-edit`,
        loadComponent: () =>
            import('@/app/domains/erp/storage-layout/pages/section-edit/section-edit.page').then(
                (m) => m.SectionEditPage
            ),
    },
]
